// Origen de los tiles del mapa.
//
// Upstream apuntaba directo a `https://{s}.tile.openstreetmap.org/...`, lo que en una herramienta
// de investigación es una fuga real: cada tile que pide el navegador le dice al proveedor QUÉ
// coordenadas está mirando el investigador, desde su propia IP. El patrón de peticiones dibuja la
// zona de interés de una investigación.
//
// Por defecto se usa `/tiles/`, servido por nuestro propio nginx, que hace de proxy con caché
// hacia OSM (ver frontend/nginx.conf). OSM sigue recibiendo la petición, pero solo ve la IP del
// servidor y no puede correlacionarla con un usuario ni con una sesión. `REACT_APP_TILE_URL`
// permite apuntar a un servidor de tiles propio y cerrar la fuga del todo.
export const OSM_TILE_URL = process.env.REACT_APP_TILE_URL || '/tiles/{z}/{x}/{y}.png';
export const OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
